<template>
  <main>
    <b-container v-if="apiReady">
      <div class="section-header">
        <h1 class="heading">Settings</h1>

        <div class="actions"></div>
      </div>

      <div class="layoutcard">
        <b-row>
          <b-col cols="8" lg="7">
            <b-form @submit.prevent="submit">
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    id="input-group-recentyear"
                    label="Recent year"
                    label-for="input-recentyear"
                  >
                    <b-form-input
                      id="input-recentyear"
                      v-model="form.recentyear"
                      v-validate="{
                        required: true,
                        numeric: true,
                        min_value: form.startyear,
                        max_value: form.stopyear,
                      }"
                      type="text"
                      placeholder="Recent year"
                      size="lg"
                      data-vv-name="recent year"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                  <b-form-group
                    id="input-group-startyear"
                    label="Start year"
                    label-for="input-startyear"
                  >
                    <b-form-input
                      id="input-startyear"
                      v-model="form.startyear"
                      v-validate="{
                        required: true,
                        numeric: true,
                        min_value: 0,
                        max_value: form.stopyear,
                      }"
                      type="text"
                      placeholder="Start year"
                      size="lg"
                      data-vv-name="start year"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                  <b-form-group
                    id="input-group-stopyear"
                    label="Stop year"
                    label-for="input-stopyear"
                  >
                    <b-form-input
                      id="input-stopyear"
                      v-model="form.stopyear"
                      v-validate="{
                        required: true,
                        numeric: true,
                        min_value: form.startyear,
                      }"
                      type="text"
                      placeholder="Stop year"
                      size="lg"
                      data-vv-name="stop year"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col class="text-right" cols="12">
                  <div class="form-footer">
                    <b-btn variant="primary" size="lg" type="submit"
                      ><i class="fa fa-download" /> Save</b-btn
                    >
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import { mapState } from "vuex";
import DataSettings from "@/helpers/DataSettings";
import InitApi from "../Shared/InitApi";

export default {
  name: "ExploreSettings",
  extends: InitApi,
  data() {
    return {
      form: {
        recentyear: 0,
        startyear: 0,
        stopyear: 0,
      },
    };
  },
  computed: {
    ...mapState({
      apiReady: (state) => state.api.apiReady,
    }),
  },
  mounted() {
    this.form = DataSettings.getSettings("exploreConfig");
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error",
          });
          return;
        }

        DataSettings.setSettings("exploreConfig", this.form);

        this.$toasted.show("Settings saved");
      });
    },
  },
};
</script>
